import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener } from 'src/app/_helpers/ga-events';
import { removeGAEventListener } from 'src/app/_helpers/ga-events';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import * as Sentry from "@sentry/angular-ivy";
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

@Component({
  selector: 'tp-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  submitted = false;
  tokenValue: string = '';
  errorMsg: string = '';
  errorValue = "success";
  infobox = true;
  passwordVisible: boolean = false;
  passwordVisible2: boolean = false;
  passwordStrength: any;
  passwordStrengthAlternate: number[] = [];
  passwordStrengthValues: any = {
    hasDigit: false,
    hasSpecialChar: false,
    hasUpperCase: false,
    hasLowerCase: false,
    minLength: false,
  }

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService,
  ) { }

  ngOnInit() {
    pageLoadEvent("auth-change-password_page")
    addGAEventListener();
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
    this.infobox = true;
    this.validateForm = this.fb.group({
      password: [null, [Validators.required, Validators.minLength(9)]],
      confirm: ['', [this.confirmValidator]]
    });
    this.route.queryParams.subscribe(params => {
      this.tokenValue = params['token'];
    },
    (error:any) => {
      Sentry.captureMessage('Error: ' + error);
    });

  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() { return this.validateForm.controls; }

  validateConfirmPassword(): void {
    setTimeout(() => this.validateForm.controls.confirm.updateValueAndValidity());
  }

  confirmValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  submitForm() {
    this.submitted = true;
    if (this.validateForm.valid) {
      let body = {
        "token": this.tokenValue,
        "password": this.f.password.value
      }
      this.authService.changePassword(body).subscribe(
        data => {
          this.infobox = false;
          this.errorMsg = data.response;
          this.errorValue = data.error ? 'error' : 'success';
          if (data.error != true) {
            this.router.navigate(['/auth/login']);
            // this.createNotificationbox('success', data.response);
          } else {
            // this.createNotificationbox('error', data.response);
          }
        },
        (error:any) => {
          Sentry.captureMessage('Error: ' + error);
        }
      );
    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }

  }

  createNotificationbox(type: string, data: string): void {
    this.notification.create(
      type,
      data,
      data
    );
  }

  togglePasswordVisibility() {
    clickGAEvent("show_password", "password-visibility-toggle_click", "auth-change-password_page")
    this.passwordVisible = !this.passwordVisible;
  }

  togglePasswordVisibility2() {
    clickGAEvent("show_password", "password-visibility-toggle_click", "auth-change-password_page")
    this.passwordVisible2 = !this.passwordVisible2;
  }

  onPasswordChange($event: any) {
    this.passwordStrengthValues = {
      hasDigit: false,
      hasSpecialChar: false,
      hasUpperCase: false,
      hasLowerCase: false,
      minLength: false,
    }
    this.passwordStrength = this.getPasswordStrength();
  }

  getPasswordStrength() {
    const password = this.f.password.value;
    const minLength = password?.length > 8;
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)
    const hasUpperCase = password.toLowerCase() !== password;
    const hasLowerCase = password.toUpperCase() !== password;
    let strength = [];
    let alternate = [];

    if (hasDigit) {
      this.passwordStrengthValues.hasDigit = true;
      strength.push(1)
    }
    if (hasSpecialChar) {
      this.passwordStrengthValues.hasSpecialChar = true;
      strength.push(1);
    }
    if (hasUpperCase) {
      this.passwordStrengthValues.hasUpperCase = true;
      strength.push(1);
    }
    if (hasLowerCase) {
      this.passwordStrengthValues.hasLowerCase = true;
      strength.push(1);
    }
    if (minLength) {
      this.passwordStrengthValues.minLength = true;
      strength.push(1);
    }

    for (let i = 0; i < 5 - strength.length; i++) {
      alternate.push(1);
    }
    this.passwordStrengthAlternate = alternate;
    return strength;
  }

  triggerGAInput(): void {
    clickGAEvent("input_text", "confirm-password_click", "auth-change-password_page")
  }
  triggerGAButton(): void {
    clickGAEvent("button_click", "change-password_click", "auth-change-password_page")
  }
}
